"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f120 = void 0;
exports.f120 = {
    "x": [
        "Cyrl"
    ],
    "xaa": [
        "Latn"
    ],
    "xab": [
        "Latn"
    ],
    "xac": [
        "Zyyy"
    ],
    "xad": [
        "Zyyy"
    ],
    "xae": [
        "Zyyy"
    ],
    "xag": [
        "Aghb"
    ],
    "xai": [
        "Latn"
    ],
    "xaj": [
        "Latn"
    ],
    "xak": [
        "Latn"
    ],
    "xal": [
        "Cyrl",
        "Mong"
    ],
    "xam": [
        "Latn"
    ],
    "xan": [
        "Ethi"
    ],
    "xao": [
        "Latn"
    ],
    "xap": [
        "Zyyy"
    ],
    "xaq": [
        "Zyyy"
    ],
    "xar": [
        "Latn"
    ],
    "xas": [
        "Cyrl"
    ],
    "xat": [
        "Latn"
    ],
    "xau": [
        "Latn"
    ],
    "xav": [
        "Latn"
    ],
    "xaw": [
        "Latn"
    ],
    "xay": [
        "Latn"
    ],
    "xbb": [
        "Latn"
    ],
    "xbc": [
        "Grek",
        "Mani"
    ],
    "xbd": [
        "Latn"
    ],
    "xbe": [
        "Latn"
    ],
    "xbg": [
        "Latn"
    ],
    "xbi": [
        "Latn"
    ],
    "xbj": [
        "Latn"
    ],
    "xbm": [
        "Latn"
    ],
    "xbn": [
        "Latn"
    ],
    "xbo": [
        "Zyyy"
    ],
    "xbp": [
        "Latn"
    ],
    "xbr": [
        "Latn"
    ],
    "xbw": [
        "Latn"
    ],
    "xby": [
        "Latn"
    ],
    "xcb": [
        "Zyyy"
    ],
    "xcc": [
        "Zyyy"
    ],
    "xce": [
        "Zyyy"
    ],
    "xcg": [
        "Zyyy"
    ],
    "xch": [
        "Zyyy"
    ],
    "xcl": [
        "Armn"
    ],
    "xcm": [
        "Zyyy"
    ],
    "xcn": [
        "Zyyy"
    ],
    "xco": [
        "Arab",
        "Chrs"
    ],
    "xcr": [
        "Cari"
    ],
    "xct": [
        "Tibt"
    ],
    "xcu": [
        "Zyyy"
    ],
    "xcv": [
        "Zyyy"
    ],
    "xcw": [
        "Zyyy"
    ],
    "xcy": [
        "Zyyy"
    ],
    "xda": [
        "Latn"
    ],
    "xdc": [
        "Latn",
        "Grek"
    ],
    "xdk": [
        "Latn"
    ],
    "xdm": [
        "Zyyy"
    ],
    "xdo": [
        "Latn"
    ],
    "xdy": [
        "Latn"
    ],
    "xeb": [
        "Zyyy"
    ],
    "xed": [
        "Latn"
    ],
    "xeg": [
        "Latn"
    ],
    "xel": [
        "Zyyy"
    ],
    "xem": [
        "Latn"
    ],
    "xep": [
        "Zyyy"
    ],
    "xer": [
        "Latn"
    ],
    "xes": [
        "Latn"
    ],
    "xet": [
        "Latn"
    ],
    "xeu": [
        "Latn"
    ],
    "xfa": [
        "Zyyy"
    ],
    "xga": [
        "Zyyy"
    ],
    "xgb": [
        "Latn"
    ],
    "xgd": [
        "Latn"
    ],
    "xgf": [
        "Zyyy"
    ],
    "xgg": [
        "Latn"
    ],
    "xgi": [
        "Latn"
    ],
    "xgl": [
        "Zyyy"
    ],
    "xgm": [
        "Latn"
    ],
    "xgr": [
        "Zyyy"
    ],
    "xgu": [
        "Latn"
    ],
    "xgw": [
        "Latn"
    ],
    "xh": [
        "Latn",
        "Brai"
    ],
    "xha": [
        "Zyyy"
    ],
    "xhc": [
        "Zyyy"
    ],
    "xhd": [
        "Sarb"
    ],
    "xhe": [
        "Arab"
    ],
    "xhr": [
        "Ital"
    ],
    "xht": [
        "Zyyy"
    ],
    "xhu": [
        "Zyyy"
    ],
    "xhv": [
        "Latn"
    ],
    "xib": [
        "Zyyy"
    ],
    "xii": [
        "Latn"
    ],
    "xil": [
        "Zyyy"
    ],
    "xin": [
        "Latn"
    ],
    "xir": [
        "Latn"
    ],
    "xis": [
        "Orya"
    ],
    "xiv": [
        "Zyyy"
    ],
    "xiy": [
        "Latn"
    ],
    "xjb": [
        "Latn"
    ],
    "xjt": [
        "Latn"
    ],
    "xka": [
        "Arab"
    ],
    "xkb": [
        "Latn"
    ],
    "xkc": [
        "Zyyy"
    ],
    "xkd": [
        "Latn"
    ],
    "xke": [
        "Latn"
    ],
    "xkf": [
        "Tibt"
    ],
    "xkg": [
        "Latn"
    ],
    "xki": [
        "Zxxx"
    ],
    "xkj": [
        "Arab"
    ],
    "xkk": [
        "Zyyy"
    ],
    "xkl": [
        "Latn"
    ],
    "xkn": [
        "Latn"
    ],
    "xko": [
        "Zyyy"
    ],
    "xkp": [
        "Zyyy"
    ],
    "xkq": [
        "Latn"
    ],
    "xkr": [
        "Latn"
    ],
    "xks": [
        "Latn"
    ],
    "xkt": [
        "Latn"
    ],
    "xku": [
        "Latn"
    ],
    "xkv": [
        "Latn"
    ],
    "xkw": [
        "Latn"
    ],
    "xkx": [
        "Latn"
    ],
    "xky": [
        "Latn"
    ],
    "xkz": [
        "Latn",
        "Tibt"
    ],
    "xla": [
        "Latn"
    ],
    "xlb": [
        "Zyyy"
    ],
    "xlc": [
        "Lyci"
    ],
    "xld": [
        "Lydi"
    ],
    "xle": [
        "Zyyy"
    ],
    "xlg": [
        "Zyyy"
    ],
    "xli": [
        "Zyyy"
    ],
    "xln": [
        "Zyyy"
    ],
    "xlo": [
        "Zyyy"
    ],
    "xlp": [
        "Zyyy"
    ],
    "xls": [
        "Latn"
    ],
    "xlu": [
        "Zyyy"
    ],
    "xly": [
        "Elym"
    ],
    "xma": [
        "Zyyy"
    ],
    "xmb": [
        "Latn"
    ],
    "xmc": [
        "Latn"
    ],
    "xmd": [
        "Latn"
    ],
    "xme": [
        "Zyyy"
    ],
    "xmf": [
        "Geor"
    ],
    "xmg": [
        "Latn",
        "Zzzz"
    ],
    "xmh": [
        "Latn"
    ],
    "xmj": [
        "Latn"
    ],
    "xmk": [
        "Zyyy"
    ],
    "xml": [
        "Zxxx"
    ],
    "xmm": [
        "Latn"
    ],
    "xmn": [
        "Mani"
    ],
    "xmo": [
        "Latn"
    ],
    "xmp": [
        "Latn"
    ],
    "xmq": [
        "Latn"
    ],
    "xmr": [
        "Merc"
    ],
    "xms": [
        "Zxxx"
    ],
    "xmt": [
        "Latn"
    ],
    "xmu": [
        "Latn"
    ],
    "xmv": [
        "Latn"
    ],
    "xmw": [
        "Latn"
    ],
    "xmx": [
        "Latn"
    ],
    "xmy": [
        "Latn"
    ],
    "xmz": [
        "Latn"
    ],
    "xna": [
        "Narb"
    ],
    "xnb": [
        "Latn"
    ],
    "xng": [
        "Zyyy"
    ],
    "xnh": [
        "Zyyy"
    ],
    "xni": [
        "Latn"
    ],
    "xnj": [
        "Latn"
    ],
    "xnk": [
        "Latn"
    ],
    "xnm": [
        "Latn"
    ],
    "xnn": [
        "Latn"
    ],
    "xno": [
        "Zyyy"
    ],
    "xnq": [
        "Latn"
    ],
    "xnr": [
        "Deva"
    ],
    "xns": [
        "Zyyy"
    ],
    "xnt": [
        "Zyyy"
    ],
    "xnu": [
        "Latn"
    ],
    "xny": [
        "Latn"
    ],
    "xnz": [
        "Arab",
        "Copt",
        "Latn"
    ],
    "xoc": [
        "Latn"
    ],
    "xod": [
        "Latn"
    ],
    "xog": [
        "Latn"
    ],
    "xoi": [
        "Latn"
    ],
    "xok": [
        "Latn"
    ],
    "xom": [
        "Latn",
        "Ethi"
    ],
    "xon": [
        "Latn",
        "Brai"
    ],
    "xoo": [
        "Latn"
    ],
    "xop": [
        "Latn"
    ],
    "xor": [
        "Latn"
    ],
    "xow": [
        "Latn"
    ],
    "xpa": [
        "Latn"
    ],
    "xpb": [
        "Latn"
    ],
    "xpc": [
        "Zyyy"
    ],
    "xpd": [
        "Latn"
    ],
    "xpf": [
        "Latn"
    ],
    "xpg": [
        "Grek"
    ],
    "xph": [
        "Latn"
    ],
    "xpi": [
        "Ogam"
    ],
    "xpj": [
        "Latn"
    ],
    "xpk": [
        "Latn"
    ],
    "xpl": [
        "Latn"
    ],
    "xpm": [
        "Cyrl"
    ],
    "xpn": [
        "Latn"
    ],
    "xpo": [
        "Latn"
    ],
    "xpp": [
        "Zyyy"
    ],
    "xpq": [
        "Zyyy"
    ],
    "xpr": [
        "Prti"
    ],
    "xps": [
        "Zyyy"
    ],
    "xpt": [
        "Latn"
    ],
    "xpu": [
        "Phnx"
    ],
    "xpv": [
        "Latn"
    ],
    "xpw": [
        "Latn"
    ],
    "xpx": [
        "Latn"
    ],
    "xpy": [
        "Zyyy"
    ],
    "xpz": [
        "Latn"
    ],
    "xqa": [
        "Zyyy"
    ],
    "xqt": [
        "Zyyy"
    ],
    "xra": [
        "Latn"
    ],
    "xrb": [
        "Latn"
    ],
    "xrd": [
        "Latn"
    ],
    "xre": [
        "Latn"
    ],
    "xrg": [
        "Latn"
    ],
    "xri": [
        "Latn"
    ],
    "xrm": [
        "Cyrl"
    ],
    "xrn": [
        "Cyrl"
    ],
    "xrr": [
        "Zyyy"
    ],
    "xrt": [
        "Zyyy"
    ],
    "xru": [
        "Latn"
    ],
    "xrw": [
        "Latn"
    ],
    "xsa": [
        "Sarb"
    ],
    "xsb": [
        "Latn"
    ],
    "xsc": [
        "Zyyy"
    ],
    "xsd": [
        "Zyyy"
    ],
    "xse": [
        "Latn"
    ],
    "xsh": [
        "Latn"
    ],
    "xsi": [
        "Latn"
    ],
    "xsm": [
        "Latn"
    ],
    "xsn": [
        "Latn"
    ],
    "xso": [
        "Zyyy"
    ],
    "xsp": [
        "Latn"
    ],
    "xsq": [
        "Latn"
    ],
    "xsr": [
        "Deva",
        "Tibt"
    ],
    "xss": [
        "Cyrl"
    ],
    "xsu": [
        "Latn"
    ],
    "xsv": [
        "Zyyy"
    ],
    "xsy": [
        "Latn"
    ],
    "xta": [
        "Latn"
    ],
    "xtb": [
        "Latn"
    ],
    "xtc": [
        "Latn"
    ],
    "xtd": [
        "Latn"
    ],
    "xte": [
        "Latn"
    ],
    "xtg": [
        "Zyyy"
    ],
    "xth": [
        "Latn"
    ],
    "xti": [
        "Latn"
    ],
    "xtj": [
        "Latn"
    ],
    "xtl": [
        "Latn"
    ],
    "xtm": [
        "Latn"
    ],
    "xtn": [
        "Latn"
    ],
    "xto": [
        "Zyyy"
    ],
    "xtp": [
        "Latn"
    ],
    "xtq": [
        "Brah",
        "Khar"
    ],
    "xtr": [
        "Zyyy"
    ],
    "xts": [
        "Latn"
    ],
    "xtt": [
        "Latn"
    ],
    "xtu": [
        "Latn"
    ],
    "xtv": [
        "Latn"
    ],
    "xtw": [
        "Latn"
    ],
    "xty": [
        "Latn"
    ],
    "xtz": [
        "Latn"
    ],
    "xua": [
        "Zyyy"
    ],
    "xub": [
        "Knda",
        "Mlym",
        "Taml"
    ],
    "xud": [
        "Latn"
    ],
    "xug": [
        "Zyyy"
    ],
    "xuj": [
        "Taml"
    ],
    "xul": [
        "Latn"
    ],
    "xum": [
        "Latn",
        "Ital"
    ],
    "xun": [
        "Latn"
    ],
    "xuo": [
        "Latn"
    ],
    "xup": [
        "Zyyy"
    ],
    "xur": [
        "Zyyy"
    ],
    "xut": [
        "Latn"
    ],
    "xuu": [
        "Latn"
    ],
    "xve": [
        "Ital"
    ],
    "xvi": [
        "Arab"
    ],
    "xvn": [
        "Latn"
    ],
    "xvo": [
        "Latn"
    ],
    "xvs": [
        "Latn"
    ],
    "xwa": [
        "Latn"
    ],
    "xwc": [
        "Zyyy"
    ],
    "xwd": [
        "Latn"
    ],
    "xwe": [
        "Latn"
    ],
    "xwg": [
        "Zyyy"
    ],
    "xwj": [
        "Latn"
    ],
    "xwk": [
        "Latn"
    ],
    "xwl": [
        "Latn"
    ],
    "xwo": [
        "Cyrl"
    ],
    "xwr": [
        "Latn"
    ],
    "xwt": [
        "Latn"
    ],
    "xww": [
        "Latn"
    ],
    "xxb": [
        "Latn"
    ],
    "xxk": [
        "Latn"
    ],
    "xxm": [
        "Latn"
    ],
    "xxr": [
        "Latn"
    ],
    "xxt": [
        "Latn"
    ],
    "xya": [
        "Latn"
    ],
    "xyb": [
        "Latn"
    ],
    "xyj": [
        "Latn"
    ],
    "xyk": [
        "Latn"
    ],
    "xyl": [
        "Latn"
    ],
    "xyt": [
        "Latn"
    ],
    "xyy": [
        "Latn"
    ],
    "xzh": [
        "Marc"
    ],
    "xzm": [
        "Zyyy"
    ],
    "xzp": [
        "Latn"
    ]
};
